import apiClient from 'services/axios'
import routeNames from 'routeNames/backendRouteNames'

export default class DesksService {
  constructor() {
    this.apiClient = apiClient
    this.routeNames = routeNames
  }

  createDesk = async ({ body }) => {
    return this.apiClient.post(this.routeNames.CREATE_DESK.path, body)
  }

  getDesks = async () => {
    return this.apiClient.get(this.routeNames.GET_DESKS.path)
  }

  getDesk = async ({ id }) => {
    let route = this.routeNames.GET_DESK.path
    route = route.replace(':id', id)
    return this.apiClient.get(route)
  }

  updateDesk = async ({ body, id }) => {
    let route = this.routeNames.UPDATE_DESK.path
    route = route.replace(':id', id)
    return this.apiClient.patch(route, body)
  }

  getDeskTickets = async ({ id }) => {
    let route = this.routeNames.GET_DESK_TICKETS.path
    route = route.replace(':id', id)
    return this.apiClient.get(route)
  }

  getDeskTicketType = async ({ id }) => {
    let route = this.routeNames.GET_DESK_TICKET_TYPE.path
    route = route.replace(':id', id)
    return this.apiClient.get(route)
  }
}
